import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Dashboard from '../components/Dashboard';
import ChatInterface from '../components/ChatInterface';
import AgentSidebar from '../components/AgentSidebar';
import AgentInfoPanel from '../components/AgentInfoPanel';
import TacticalReadout from '../components/TacticalReadout';
import { MessageSquare, BarChart3 } from 'lucide-react';

const DashboardPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [activeView, setActiveView] = useState('chat');
  const [chatPrompt, setChatPrompt] = useState('');
  const [activeAgent, setActiveAgent] = useState('tactical');

  const handleNavigateToUpload = () => navigate('/upload');
  const handleNavigateToHistory = () => navigate('/history');
  const handleViewAnalysis = (analysisId) => navigate(`/analysis/${analysisId}`);
  const handleAgentShortcut = (prompt) => { setChatPrompt(prompt); setActiveView('chat'); };
  const handlePromptUsed = () => setChatPrompt('');

  return (
    <div className="min-h-screen" style={{ background: '#f8fafc' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5">

        {/* VIEW SWITCHER */}
        <div className="mb-5 flex gap-0.5 p-1 rounded-lg" style={{ background: '#fff', border: '1px solid #e2e8f0' }}>
          {[
            { id: 'chat', icon: MessageSquare, label: 'AI Chat' },
            { id: 'dashboard', icon: BarChart3, label: t('nav.dashboard') },
          ].map(v => (
            <button key={v.id} onClick={() => setActiveView(v.id)}
              className="flex-1 flex items-center justify-center gap-2 py-2.5 px-4 rounded-md text-sm font-semibold transition-all"
              style={{
                background: activeView === v.id ? '#0a1628' : 'transparent',
                color: activeView === v.id ? '#f59e0b' : '#64748b',
              }}>
              <v.icon className="h-4 w-4" />
              <span>{v.label}</span>
            </button>
          ))}
        </div>

        {activeView === 'chat' ? (
          <div className="flex gap-0 rounded-xl overflow-hidden shadow-sm" style={{ border: '1px solid #e2e8f0', background: '#fff', minHeight: 'calc(100vh - 180px)' }}>
            <div className="hidden lg:block" style={{ width: 200, flexShrink: 0 }}>
              <AgentSidebar activeAgent={activeAgent} onAgentSelect={setActiveAgent} onNewAnalysis={handleNavigateToUpload} />
            </div>
            <div className="flex-1 min-w-0">
              <ChatInterface initialPrompt={chatPrompt} onPromptUsed={handlePromptUsed} activeAgent={activeAgent} />
            </div>
            <div className="hidden xl:block" style={{ width: 310, flexShrink: 0, borderLeft: '1px solid #e2e8f0' }}>
              <div className="h-full overflow-y-auto">
                <TacticalReadout />
                <div style={{ borderTop: '1px solid #e2e8f0' }}>
                  <AgentInfoPanel activeAgent={activeAgent} />
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="grid lg:grid-cols-3 gap-5">
            <div className="lg:col-span-2">
              <Dashboard onNavigateToUpload={handleNavigateToUpload} onNavigateToHistory={handleNavigateToHistory}
                onViewAnalysis={handleViewAnalysis} onAgentShortcut={handleAgentShortcut} />
            </div>
            <div>
              <div className="sticky top-20"><TacticalReadout /></div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default DashboardPage;
